export const SELECT_DATE = 'select-date';

export const SELECT_DATE_OPTION = {
  label: 'Select date...',
  value: SELECT_DATE,
};
